


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ReportComparisonViewModel } from '@/services/api/nswag/stapiclient_generated';
import StExplanation from '@/components/basic/StExplanation.vue';

@Component({
  components: { StExplanation },
})
export default class ComparisonCard extends Vue {
  @Prop() model!: ReportComparisonViewModel;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: '€' }) unit!: string;
}
